export default {
    currentUserCan(state) {
        return permission => state.navbar?.user?.permissions && state.navbar.user.permissions.indexOf(permission) >= 0;
    },
    isCurrentAccountOwner(state) {
        return state.navbar?.user?.currentUserAccount?.is_account_owner ?? false
    }
}
